export default "__VITE_ASSET__ETM0ZaPi__"